<template>
  <v-app>
    <v-main>
      <router-view/>
      <v-snackbar bottom right :value="updateExists" v-show="updateExists" :timeout="0" color="primary">
        بروزرسانی جدید موجود است
        <v-btn text @click="refreshApp">
          بروز رسانی
        </v-btn>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script lang="js">
import { defineComponent } from 'vue'
import update from '@/plugins/update.js'
export default defineComponent({
  name: 'App',

  data () {
    return {
//
    }
  },
  mixins: [update],
})
</script>
